import { updateGeofenceLocations, updateGeofenceRegisteredDevices } from '../reducers/geofenceSettings';

const actions = {
    updateGeofenceLocationList: (geofenceLocationList) => async (dispatch) => {
        dispatch(updateGeofenceLocations({ data: geofenceLocationList }));
    },
    updateGeofenceRegisteredDevicesList: (geofenceDevicesList) => async (dispatch) => {
        dispatch(actions.updateGeofenceRegisteredDevicesListAction(geofenceDevicesList));
    },
    updateGeofenceRegisteredDevicesListAction: (data) => (dispatch) => {
        dispatch(updateGeofenceRegisteredDevices({ data }));
    },
};

export default actions;
